<template>
  <footer>
    <div class="container">
      <div class="footer-top">
        <div class="logo-wrapper">
          <div class="row">
            <div class="col-md-6 col-6 align-self-center">
              <div class="logo">
                <img src="../assets/images/icon/logo-icon.svg" alt="logo-icon">
              </div>
            </div>
            <div class="col-md-6 col-6 align-self-center">
              <ul class="social-icons">
                <li><a target="_blank" href="https://x.com/cloudblastio"><img src="../assets/images/icon/x.png" alt="twitter"></a></li>
                <li><a target="_blank" href="https://discord.gg/rMMZs6jpN6"><img src="../assets/images/icon/discord-icon.svg" alt="discord"></a></li>
                <li><a target="_blank" href="https://www.facebook.com/cloudblastio"><img src="../assets/images/icon/facebook.svg" alt="facebook"></a></li>
                <li><a target="_blank" href="https://t.me/cloudblast"><img src="../assets/images/icon/telegram.svg" alt="telegram"></a></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-lg-6">
            <div class="row">
              <div class="col-md-4 col-4">
                <div class="footer-menu">
                  <strong>Products</strong>
                  <ul class="links">
                    <li><RouterLink to="/">Features</RouterLink></li>
                    <li><RouterLink to="/pricing">Pricing</RouterLink></li>
                    <li><RouterLink to="/blog/1">Blog</RouterLink></li>
                    <li><RouterLink to="/tools">Tools</RouterLink></li>
                  </ul>
                </div>
              </div>
              <div class="col-md-4 col-4">
                <div class="footer-menu">
                  <strong>Solutions</strong>
                  <ul class="links">
                    <li><RouterLink to="/about">DDoS Protection</RouterLink></li>
                    <li><RouterLink to="/about">Our Network</RouterLink></li>
                    <li><a target="_blank" href="https://status.cloudblast.io/">Service Status</a></li>
                    <li><a target="_blank" href="https://docs.cloudblast.io/">API Documentation</a></li>
                  </ul>
                </div>
              </div>
              <div class="col-md-4 col-4">
                <div class="footer-menu">
                  <strong>Company</strong>
                  <ul class="links">
                    <li><RouterLink to="/about">About Us</RouterLink></li>
                    <li><RouterLink to="/contact">Contacts</RouterLink></li>
                    <li><RouterLink to="/help">Help Center</RouterLink></li>
                    <li><a target="_blank" href="https://lg.cloudblast.io/">Looking Glass</a></li>
                  </ul>
                </div>
              </div>
            </div>
            <img style="width: 85%; margin-top: 30px;" src="../assets/images/methods.png" alt="support-agent-icon">
            <div class="have-question">
              <p>Have a question in mind? <RouterLink to="/contact">talk to us</RouterLink></p>
              <img src="../assets/images/icon/support-agent-icon.svg" alt="support-agent-icon">
            </div>
          </div>
          <div class="col-lg-1"></div>
          <div class="col-md-6 col-lg-5">
            <strong>Newsletter</strong>
            <form @submit.prevent="submitNewsletter" class="newsletter">
              
              <div class="form-group">
                <div v-if="confirmationMessage" class="confirmation-message">
                  {{ confirmationMessage }}
                </div>

                <label for="email">EMAIL</label>
                <div class="input">
                  <input type="email" class="form-control" id="email" v-model="email" placeholder="Email address.." required>
                  <img src="../assets/images/icon/email-icon.svg" alt="email-icon" class="email-icon">
                </div>
              </div>
              <div class="row">
                <div class="col-md-7 align-self-center">
                  <div class="text">
<!--                    <div class="tick-icon">
                      <input type="checkbox" id="myCheckbox"/>
                                            <img src="../assets/images/icon/tick-icon.svg" alt="tick-icon">
                    </div>-->
                    <label class="main">I agree with <RouterLink to="/terms">Terms of Use</RouterLink> and <RouterLink to="/privacy">Privacy Policy</RouterLink>.
                      <input type="checkbox">
                      <span class="geekmark"> <img src="../assets/images/icon/tick-icon.svg" alt="tick-icon"></span>
                    </label>
<!--                    <label for="myCheckbox"></label>-->
                  </div>
                </div>
                <div class="col-md-5  align-self-center">
                  <div class="btn-wrapper">
                    <button type="submit" class="btn-style transparent material-bubble" @click="recaptcha"> Send</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="container">
        <div class="row">
          <div class="col-md-7">
            <span>©2024 All Right Reserved, CloudBlast.io | CloudBlast LLC</span>
          </div>
          <div class="col-md-5">
            <ul class="bottom-menu">
              <li><RouterLink to="/terms">Terms of use</RouterLink></li>
              <li><RouterLink to="/privacy">Privacy Policy</RouterLink></li>
              <li><RouterLink to="/terms">Acceptable Use Policy</RouterLink></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>




<script>
import { defineComponent } from 'vue';
import axios from 'axios'; 
import { createApp } from 'vue'
import { useReCaptcha } from "vue-recaptcha-v3";


export default defineComponent({
  
  name: 'FooterComponent',


data() {
    return {
      email: '',
      confirmationMessage: '',
      recaptchaToken: '', // Add a property to store the recaptcha token
    };
  },
  methods: {
    async submitNewsletter() {
    try {
        // First, get the recaptcha token
        this.recaptchaToken = await this.recaptcha();

        // Check if the reCAPTCHA token is received
        if (!this.recaptchaToken) {
            this.confirmationMessage = 'reCAPTCHA verification failed. Please try again.';
            return;
        }

        // Then, send the token along with the email in the POST request
        const response = await axios.post('https://cloudblast.io/newslettersub.php', {
            email: this.email,
            token: this.recaptchaToken, // Send the token here
        });

        // Check response data for specific error messages
        if (response.data === 'Invalid reCAPTCHA. Please try again.') {
            this.confirmationMessage = 'Invalid reCAPTCHA. Please try again.';
        } else if (response.data === 'No email or reCAPTCHA token provided.') {
            this.confirmationMessage = 'No email or reCAPTCHA token provided. Please try again.';
        } else if (response.data === 'Invalid or no email provided.') {
            this.confirmationMessage = 'No valid email provided. Please try again.';
        } else if (response.data === 'Email successfully added to the newsletter.') {
            this.confirmationMessage = 'Thank you for subscribing to our newsletter!';
        } else {
            // Handle other unforeseen responses
            this.confirmationMessage = 'An unexpected error occurred. Please try again.';
        }
    } catch (error) {
        console.error(error);
        this.confirmationMessage = 'Failed to subscribe. Please try again.';
    }
},

  },
  setup() {
    const { executeRecaptcha, recaptchaLoaded } = useReCaptcha();

    // Modify this method to return the token
    const recaptcha = async () => {
      await recaptchaLoaded();
      const token = await executeRecaptcha("newsletter_subscribe"); // Changed action to "newsletter_subscribe"
      return token; // Return the token
    };

    return {
      recaptcha,
    };
  },
});
</script>


